import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FundraiseSection() {
  return <Section background="ivory" className="border-t border-purple-200" data-id="element-138">
      <div className="max-w-4xl mx-auto glass-panel rounded-3xl p-8 md:p-16 relative overflow-hidden" data-id="element-139">
        <div className="absolute top-0 right-0 w-64 h-64 bg-purple-200/20 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-140"></div>

        <div className="relative z-10 text-center mb-12" data-id="element-141">
          <FadeIn data-id="element-142">
            <div className="text-sm uppercase tracking-widest text-purple-700 font-semibold mb-4" data-id="element-143">
              Investment Opportunity
            </div>
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-4" data-id="element-144">
              Raising $500,000 Seed
            </h2>
            <p className="text-lg text-charcoal/70 italic" data-id="element-145">
              Backing Fem Entity is investing in the future of women's health
              infrastructure.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 relative z-10" data-id="element-146">
          <FadeIn delay={200} data-id="element-147">
            <div className="bg-white/60 p-6 rounded-2xl h-full" data-id="element-148">
              <h4 className="font-serif text-xl text-charcoal mb-4 border-b border-purple-200 pb-2" data-id="element-149">
                Use of Funds
              </h4>
              <ul className="space-y-3 text-charcoal/70" data-id="element-150">
                <li className="flex items-center" data-id="element-151">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold mr-3" data-id="element-152"></span>{' '}
                  Platform development & AI refinement
                </li>
                <li className="flex items-center" data-id="element-153">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold mr-3" data-id="element-154"></span>{' '}
                  Customer acquisition & retention
                </li>
                <li className="flex items-center" data-id="element-155">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold mr-3" data-id="element-156"></span>{' '}
                  Practitioner network expansion
                </li>
                <li className="flex items-center" data-id="element-157">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold mr-3" data-id="element-158"></span>{' '}
                  Enterprise partnerships
                </li>
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={400} className="flex flex-col justify-center items-center bg-charcoal text-ivory p-8 rounded-2xl text-center" data-id="element-159">
            <h4 className="font-serif text-2xl mb-6" data-id="element-160">Join the Cap Table</h4>
            <p className="text-ivory/70 mb-8 text-sm" data-id="element-161">
              Request access to our data room and full investor deck.
            </p>
            <Button variant="primary" className="w-full bg-purple-700 text-white hover:bg-purple-800" data-id="element-162">
              Request Deck
            </Button>
          </FadeIn>
        </div>
      </div>
    </Section>;
}